import React from "react";
import { ArrowRight } from "lucide-react";
import { useLang } from "../../context/LangContext";

export default function Hero() {
  const { c } = useLang();
  const h = c.hero;
  return (
    <section id="top" style={{ position: "relative", overflow: "hidden" }}>
      <div className="grid-bg" style={{ position: "absolute", inset: 0, opacity: 0.6 }} />
      <div className="glow-radial" style={{ position: "absolute", inset: 0 }} />
      <div className="container-x" style={{ position: "relative", paddingTop: "11rem", paddingBottom: "5rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "2rem" }}>
          <span style={{ width: 42, height: 1, background: "var(--gold)" }} />
          <span className="eyebrow">{h.eyebrow}</span>
        </div>

        <h1 className="display" style={{ fontSize: "clamp(3rem, 8vw, 6.5rem)", maxWidth: 900, marginBottom: "2rem" }}>
          {h.title.pre}<span className="italic-gold">{h.title.em}</span>{h.title.post}
        </h1>

        <p className="body-text" style={{ maxWidth: 620, fontSize: "1.1rem", marginBottom: "2.6rem" }}>{h.para}</p>

        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "4.5rem" }}>
          <a href="#contact" className="btn-gold">{h.cta1} <ArrowRight size={15} /></a>
          <a href="#how" className="btn-outline">{h.cta2}</a>
        </div>

        <hr style={{ border: "none", borderTop: "1px solid rgba(255,255,255,0.08)", marginBottom: "2.5rem" }} />

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "1.5rem" }}>
          {h.stats.map((s) => {
            const isNum = /[0-9]/.test(s.value);
            return (
              <div key={s.label}>
                <div className="font-serif" style={{ fontSize: "2.6rem", lineHeight: 1 }}>{s.value.replace(/\+$/, "")}{isNum && <span style={{ color: "var(--gold)" }}>+</span>}</div>
                <div className="eyebrow" style={{ color: "var(--muted-2)", marginTop: "0.6rem" }}>{s.label}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", borderBottom: "1px solid rgba(255,255,255,0.06)", padding: "1.4rem 0", overflow: "hidden", background: "rgba(255,255,255,0.01)" }}>
        <div className="marquee">
          {[...h.marquee, ...h.marquee].map((item, i) => (
            <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: "2.5rem", paddingRight: "2.5rem" }}>
              <span className="font-serif" style={{ fontSize: "1.35rem", fontStyle: "italic", color: i % 2 ? "var(--gold)" : "var(--muted)", whiteSpace: "nowrap" }}>{item}</span>
              <span style={{ color: "var(--gold)", opacity: 0.5 }}>✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
